import { render, staticRenderFns } from "./GroupsGrid.vue?vue&type=template&id=e4065fc2"
import script from "./GroupsGrid.vue?vue&type=script&lang=js"
export * from "./GroupsGrid.vue?vue&type=script&lang=js"
import style0 from "./GroupsGrid.vue?vue&type=style&index=0&id=e4065fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports